<template>
    <div class="container mt-4">
        
        <div class="row" v-if="$isAllowed('read')">
            <div class="col-12">
                <cph-widget :container="'container'">
                    <div slot="header" class="full-width">
                        <div class="d-inline">
                            <h2 class="d-inline">{{$t('SIDEBAR.orders')}}</h2>
                        </div>
                        <cph-button @clicked="refreshOrders"
                                    :buttonText="$t('COMMON.refresh')"
                                    :loading="spinnerActive"
                                    :classList="'btn btn-cph-primary btn-cph-rounded float-right'">
                            refresh
                        </cph-button>
                    </div>
                    <orders-table slot="body"
                                  :orders="orders"
                                  :ordersLength="ordersLength"
                                  :orderSelected.sync="selectedOrder"
                                  @closeDetails="selectedOrder = {}"></orders-table>
                </cph-widget>
            </div>
        </div>
        
        <div class="row" v-if="selectedOrder.id && $isAllowed('readDetails')">
            <div class="col-12">
                <cph-widget :container="'container'"
                            :standOut="true"
                            :closeable="true"
                            :tabs="availableTabs"
                            :tab.sync="selectedTab"
                            @close="selectedOrder = {}">
                    <h2 slot="header">{{$t('COMMON.order') | capitalize}}: {{selectedOrder.id}}</h2>
                    <component :is="'order-' + selectedTab" slot="body"
                               @save="handleSave"
                               :cart.sync="getProductsFromCart"
                               :details="getOrderDetails"></component>
                </cph-widget>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { OrdersPerimeter } from '../../../router/perimeters/ordersPerimeter';
import OrdersTable from '../../../components/Panel/Orders/OrdersTable/OrdersTable.vue';
import OrderDetails from '../../../components/Panel/Orders/OrderDetails/OrderDetails.vue';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import CphButton from '../../../components/Shared/UI/Button/CphButton.vue';
import Filters from '../../../mixins/CphFilters.vue';

/**
 * @module Panel/orders
 * @description This component displays all orders and analytics
 * */
export default {
    name: 'OrdersView',
    data () {
        return {
            selectedOrder: {},
            availableTabs: ['Details'],
            selectedTab: 'Details',
            template: '',
            spinnerActive: false
        };
    },
    perimeters: [OrdersPerimeter],
    computed: {
        ...mapGetters({
            orders: 'getOrders',
            prices: 'getAllPrices',
            orderManagerPort: 'getOrderManagerPort',
            priceServicePort: 'getPriceServicePort'
        }),
        ordersLength () {
            if (this.orders.length === 0) {
                return 0;
            }
            return Math.ceil([...this.orders.filter(order => order)].length / 10);
        },
        getProductsFromCart: {
            get () {
                if(this.selectedOrder) {
                    let result = [];
                    for(let key in this.selectedOrder.cart) {
                        let item = this.selectedOrder.cart[key];
                        result.push(item);
                    }
                    return result;
                } else {
                    return [];
                }
            }, set (val) {
                this.selectedOrder.cart = val;
            }
        },
        getOrderDetails () {
            if(this.selectedOrder) {
                return {
                    id: this.selectedOrder.id,
                    timestamp: this.selectedOrder.timestamp,
                    userData: this.selectedOrder.userData
                };
            } else {
                return {};
            }
        }
    },
    mixins: [Filters],
    components: {
        OrdersTable,
        OrderDetails,
        CphWidget,
        CphButton
    },
    methods: {
        ...mapMutations([
            'updateOrders',
            'updateUrl',
            'updateLoadingState'
        ]),
        ...mapActions([
            'getOrderListAsync',
            'getPricesAsync'
        ]),
        async refreshOrders () {
            this.updateLoadingState(true);
            this.spinnerActive = true;
            await this.getOrderListAsync();
            this.updateLoadingState(false);
            this.$emit('closeDetails');
            this.spinnerActive = false;
            this.$forceUpdate();
        },
        async handleSave ({cart}) {
            try {
                let {data} = await this.$axios.put(`ordermanager/order/${this.selectedOrder.id}`, {cart: cart});
                this.$store.commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: 'updated order'
                });
                return {data};
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to update order'
                });
                throw new Error(err);
            }
        }
    },
    created () {
        this.refreshOrders();
    }
};
</script>
